import { render, staticRenderFns } from "./AddressLine.vue?vue&type=template&id=051bc916&scoped=true"
import script from "./AddressLine.vue?vue&type=script&lang=js"
export * from "./AddressLine.vue?vue&type=script&lang=js"
import style0 from "./AddressLine.vue?vue&type=style&index=0&id=051bc916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051bc916",
  null
  
)

/* custom blocks */
import block0 from "./AddressLine.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports